import React from 'react';
import { Chip } from '@material-ui/core';
import { REPORT_TYPE_OPTIONS, REPORT_TYPE_CHIP_COLORS } from './stalePriceReportConfig';

export default function StalePriceReportTypeChip({ reportType, style }) {
  if (!reportType) return null;
  const label = REPORT_TYPE_OPTIONS[reportType] || reportType;
  const colors = REPORT_TYPE_CHIP_COLORS[reportType] || { bg: '#eee', color: '#333' };
  return (
    <Chip
      size="small"
      label={label}
      style={{
        backgroundColor: colors.bg,
        color: colors.color,
        marginTop: 4,
        marginBottom: 4,
        ...style,
      }}
    />
  );
}
